import { TOKEN_DE_ACCESO, API_SSO_URL, API_BACKEND_URL } from '../constantes';

export const solicitar_datos = (parametros) => {
    parametros.url= API_BACKEND_URL+ parametros.url;
    return obtenerSolicitud(parametros);
};

export const solicitud_de_sso = (parametros) => {
    parametros.url= API_SSO_URL+ parametros.url;
    return obtenerSolicitud(parametros);
};

function obtenerSolicitud(parametros){

    const encabezados = new Headers({ 'Content-Type': 'application/json', })

    if(localStorage.getItem(TOKEN_DE_ACCESO)) { encabezados.append('Authorization', 'Bearer ' + localStorage.getItem(TOKEN_DE_ACCESO)) }

    const predeterminados = {headers: encabezados};
    parametros = Object.assign({}, predeterminados, parametros);

    return fetch(parametros.url, parametros)
    .then(respuesta =>
        respuesta.json().then(data => {
            if(!respuesta.ok) {
                return Promise.reject(data);
            }
            return data;
        })
    );
}
